import { useUserBuyerCompanyId } from 'src/contexts/userContext'
import { useBuyerCompanyQuery } from 'src/queries/buyer/buyerCompanies'

const useCurrentBuyerCompany = () => {
  const buyerCompanyId = useUserBuyerCompanyId()

  const { data: buyerCompany } = useBuyerCompanyQuery({ id: buyerCompanyId })

  return buyerCompany
}

export default useCurrentBuyerCompany
